import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { Observable } from 'rxjs/Observable';
import { of } from 'rxjs/observable/of';
import { catchError, map, tap } from 'rxjs/operators';

import { ComponentBaseService } from './component-base.service'
import { ServicesConstants } from '../services-constants'
import { BorsellinoProdotti } from '../_models/borsellino-prodotti';
import { Utils } from '../utils';
import { delayedRetry } from './delayed-retry';

@Injectable()
export class BorsellinoProdottiService extends ComponentBaseService {

  constructor(
    private http: HttpClient
  ) {
    super();
  }

  getServiceName(): string {
    return "BorsellinoProdottiService";
  }

  /** GET BorsellinoProdotti by id. Will 404 if id not found */
  getElencoBorselliniProdotti(): Observable<BorsellinoProdotti[]> {
    let url = `${ServicesConstants.URL_BORSELLINIPRODOTTI}`;

    return this.http.get<BorsellinoProdotti[]>(url).pipe(
      delayedRetry(),
      tap(_ => this.log(`fetched Elenco Borsellini prodotti`)),
      catchError(this.handleError<BorsellinoProdotti[]>(`getElencoBorselliniProdotti`))
    );
  }

}


// WEBPACK FOOTER //
// ./src/app/_services/borsellino-prodotti.service.ts